import Modal from 'styled-react-modal';

export default Modal.styled`
  width: 25rem;
  height: 25rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  padding: 40px 40px 40px;
  text-align: center;
  background-image: -webkit-linear-gradient(-30deg, #2b8c66 0%, #4bc397 100%);

  h3 {
    font-size: 22px;
    color: #fff;
    margin-bottom: 17px;
  }

  p {
    color: #fff;
    opacity: .8;
  }

  button {
    background-color: transparent;
    width: 170px;
    text-align: center;
    display: inline-block;
    border: 1px solid #fff;
    padding: 20px 0;
    border-radius: 6px;
    position: relative;
    font-weight: 500;
    color: #fff;
    transition: all 0.3s ease-in;
    margin-top: 22px;
  }

  button:hover {
    background: #2e916b;
  }
`;
